import React from 'react';
import { v4 as uuid } from 'uuid';
import cx from 'classnames';

type Props = {
  linearGradient?: boolean;
  className?: string;
  size?: number;
  onMouseDown?: (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
  isDarkMode?: boolean;
};

export const Sparkles = ({
  linearGradient,
  className,
  size,
  onMouseDown,
  isDarkMode
}: Props) => {
  const gradientId = uuid();
  const stroke = linearGradient ? `url(#${gradientId})` : 'currentColor';
  const startColor = isDarkMode ? '#de8fd2' : '#2f54eb';
  const endColor = isDarkMode ? '#d5c6e8' : '#9747ff';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || 24}
      height={size || 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      onMouseDown={onMouseDown}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cx('lucide', 'lucide-sparkles-icon', 'lucide-sparkles', {
        [className || '']: !!className
      })}
    >
      {linearGradient && (
        <defs>
          <linearGradient
            id={gradientId}
            x1="0"
            y1="0"
            x2="24"
            y2="24"
            gradientUnits="userSpaceOnUse"
          >
            <stop
              offset="0%"
              style={{ stopColor: startColor, stopOpacity: 1 }}
            />
            <stop
              offset="100%"
              style={{ stopColor: endColor, stopOpacity: 1 }}
            />
          </linearGradient>
        </defs>
      )}
      <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
      <path d="M20 2v4" />
      <path d="M22 4h-4" />
      <circle cx="4" cy="20" r="2" />
    </svg>
  );
};
